import React from 'react'

import ProjectView from "../../../../../../core/model2/project-view/project-view"
import SubmenuItem from "../submenu-item/submenu-item"
import ReorderList from "../../../../../../core/gd-ui/sortable-list-4/reorder-list"
import {ReorderListType} from "../../../../../../core/gd-ui/sortable-list-4/reorder-list-no-div"

const debug = false
// const debug = "ProjectSubmenuViewsReorderList"

type Props = {
    views       : ProjectView[]
    viewsNotFit : ProjectView[]

    isReadOnly? : boolean
}

export default function ProjectSubmenuViewsReorderList(props: Props) {


    const onDragCustomViewsEnd = (items: ProjectView[], reorderedItem: ProjectView, viewsNotFit: ProjectView[]) => {
        debug && console.log(debug, "onDragCustomViewsEnd", items, reorderedItem)

        // update sortPosition for visible views
        _.map(items, (item, key)=>{item.sortPosition = key})

        // update sortPosition for hidden views
        const nextKey = items.length
        _.map(viewsNotFit, (view, key)=>{
            view.sortPosition = nextKey + key
        })

        gd.projectViews.sort()
        gd.projectViews.save()
    }

    debug && console.log(debug, "render")

    const components = _.map(props.views, view=>({
        item        : view,
        component   : <SubmenuItem projectView  = {view}
                                   isReadOnly   = {props.isReadOnly}/>
    }));

    return <ReorderList type        = {ReorderListType.HORIZONTAL}
                        items       = {components}
                        keyFunction = {(item: ProjectView)=>item.id}
                        onReorder   = {(items: ProjectView[], reorderedItem: ProjectView) => onDragCustomViewsEnd(items, reorderedItem, props.viewsNotFit)}/>
}
